import { MemberAnketaNoInterviewComplete } from './MemberAnketaNoInterviewComplete';

export default MemberAnketaNoInterviewComplete;